import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { EvaluationsBalaceResults } from '@qaroni-shared/types/general-balance';

@Component({
  selector: 'qaroni-general-balance',
  templateUrl: './general-balance.component.html',
  styleUrl: './general-balance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GeneralBalanceComponent {
  readonly data = input<EvaluationsBalaceResults[]>([]);

  readonly employees = computed(() => {
    const employeeSet = new Set<string>();
    this.data().forEach(item => {
      employeeSet.add(item.employee);
    });
    return Array.from(employeeSet);
  });

  readonly groupedData = computed(() => {
    const groupedData: { [key: string]: EvaluationsBalaceResults[] } = {};
    this.data().forEach(item => {
      if (!groupedData[item.skillGroup]) {
        groupedData[item.skillGroup] = [];
      }
      groupedData[item.skillGroup].push(item);
    });
    return groupedData;
  });

  readonly skillGroups = computed(() => Object.keys(this.groupedData()));

  public requiredAvg(skillGroup: string): number {
    const group = this.groupedData()[skillGroup];
    const totalRequiredScore = group.reduce(
      (sum, item) => sum + Number(item.requiredScore),
      0
    );
    return totalRequiredScore / group.length;
  }

  public scoreSkillGroupAvg(skillGroup: string, employee: string): number {
    const group = this.groupedData()[skillGroup];
    const employeeScores: number[] = group
      .filter(item => item.employee === employee)
      .map(item => Number(item.score));
    return this.calculateAverage(employeeScores);
  }

  public scoreSkill(skillGroup: string, skillID: number, employee: string) {
    const group = this.groupedData()[skillGroup];

    const score = group
      .filter(item => item.employee === employee && item.skillId === skillID)
      .map(item => item.score);

    return Number(score.length ? score[0] : 0).toFixed(2);
  }

  private calculateAverage(numbers: number[]): number {
    const total: number = numbers.reduce(
      (sum: number, value: number) => sum + value,
      0
    );
    return numbers.length ? total / numbers.length : 0;
  }

  public getColorClass(valor: string | number) {
    if (typeof valor === 'string') {
      valor = Number(valor);
    }
    return {
      'bg-green-300': valor >= 4,
      'bg-green-200': valor >= 3 && valor < 4,
      'bg-yellow-100': valor >= 2 && valor < 3,
      'bg-red-200': valor >= 1 && valor < 2,
      'bg-red-300': valor < 1 && valor > 0,
    };
  }
}
